module.exports = __webpack_public_path__ + "static/media/Spring60min.4760fa63.png";